import React, { useState } from 'react'
import CreateCorsoForm from '../../components/Forms/CreateCorsoForm/CreateCorsoForm'
import { useLocation } from 'react-router';
import useMediaQuery from '../../hooks/useMediaQuery';
import ComebackArrow from '../../components/ComebackArrow/ComebackArrow';

const CreaCorsoPage = () => {
  const [percBar, setPercBar] = useState(25);
  const location = useLocation();
  const courseData = location.state && location.state.courseDataPerEdit;
  const isMax600px = useMediaQuery('(max-width: 600px)');

  const renderProgressBar = (perc) => {
    return (
      <div className="progress my-2" role="progressbar" aria-valuemin="0" aria-valuemax="100">
        <div className="progress-bar bg-primary" style={{'width': `${perc}%`}}></div>
      </div>
    )
  }
  
  return (
    <>
    <div className={`card custom-card w-100 shadow`}>
    <div className={`${isMax600px ? "p-1" : "p-5"}`}>
      <div className='container'>
      <ComebackArrow path={"/gestione-corsi"} />
        {renderProgressBar(percBar)}
      <div className='d-flex justify-content-between mt-4 custom-card-header'>
           <div className='d-flex gap-3'>
           <div className={`custom-icon-container`}>
                  <i className={`bi custom-icon bi-mortarboard fs-1`}></i>
                </div>
             <div className='align-self-center'>
                <span className='fs-4 d-block'>{!!courseData ? "Modifica corso" : "Crea corso"}</span>
             </div>
           </div>
         </div>
        <CreateCorsoForm 
          isUpdateMode={!!courseData}
          setPercBar={setPercBar} 
          courseDataEdit={courseData}/>
      </div>
      </div>
    </div>
    </>
  )
}

export default CreaCorsoPage